import { Component, Inject, Input } from '@angular/core';
import { ClientManagerInstanceToken, ClientManagerInterface, NotificationModel } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-object-info',
    templateUrl: './object-info.component.html',
    styleUrls: ['./object-info.component.scss'],
})
export class ObjectInfoComponent {
    @Input()
    public notification: NotificationModel;
    public displayFuncLocInfoHeader: boolean;
    public constructor(
        public readonly modalInstance: BsModalRef,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.displayFuncLocInfoHeader = this.clientManager.isNgmAP0() || this.clientManager.isPaceUS();
    }
}
